import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Row,  Spin, message } from "antd";
import { callCreateEmailFollow } from "../../../../config/api";
import { createPost } from "../../../../types/backend";
import { useState } from "react";

const AddEmailFollow = ({ open, setOpen }: any): JSX.Element => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)

  const showDrawer = () => {
    setOpen(true);
  };

  const onFinish = async (values: createPost) => {
    setLoading(true)
    const addValues: createPost = {
      ...values,
    };
    const result = await callCreateEmailFollow(addValues);
    if (result.statusCode === 201) {
      setOpen(false);
      message.success(result.message);
    } else {
      message.error(result.message);
    }
    setLoading(false)
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Spin spinning={loading}>
      <Button type="primary" onClick={showDrawer} icon={<PlusOutlined />}>
        Thêm mới
      </Button>
      <Modal
        title="Thêm Email theo dõi"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Tạo mới"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: "Please enter email" }]}>
                <Input placeholder="Please enter email" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default AddEmailFollow;
